import ModalWindowTemplate from 'text!../templates/modal-window-template.html';

export default ['$timeout', function ($timeout) {
    return {
        restrict: 'EA',
        scope: {
            index: '@',
            fullScreen: '<',
            wide: '<',
            parentScope: '='
        },
        replace: true,
        transclude: true,
        template: ModalWindowTemplate,
        link: function link(scope, element, attrs) {
            scope.windowClass = attrs.windowClass || '';
            scope.animationType = attrs.animationType || '';

            // focus a freshly-opened modal
            element[0].focus();

            $timeout(function () {
                // trigger CSS transitions
                scope.animate = true;
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/modal/directives/ModalWindow.js
// module id = 1133
// module chunks = 0